var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* eslint-disable no-restricted-imports */
import { keccak256, pack } from '@ethersproject/solidity';
import { FACTORY_ADDRESS_MAP, INIT_CODE_HASH } from '@uniswap/v2-sdk';
import { getCreate2Address } from 'ethers/lib/utils';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue, isVariable } from '../../../../Fct/generics';
import { getAllCurrencies, getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESSES } from '../constants';
import { getIsNative } from '../helpers/getToken';
import { ETH } from '../helpers/tokens';
import { RemoveLiquidityETH } from './ETH/removeLiquidityETH';
import { RemoveLiquidity } from './removeLiquidity';
export var SimpleRemoveLiquidity = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'simpleRemoveLiquidity',
    description: 'Remove liquidity from Uniswap',
    supportedContracts: ROUTER_V2_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                methodParams: {
                    tokenA: new FctAddress({ destination: 'erc20', options: getAllCurrencies({ chainId: chainId }) }),
                    tokenB: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                    liquidity: new FctValue({ destination: 'wei_amount' }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountA: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
                amountB: new FctValue({ destination: 'wei_amount', innerIndex: 1 }),
            },
        });
    },
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    getParamsOnCreate: function (_a) {
        var chainId = _a.chainId, params = _a.params, isEstimation = _a.isEstimation;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, to, deadline, tokenA, tokenB, liquidity, requiredParamsExact, requiredParamsExact_1, requiredParamsExact_1_1, param, requiredParams, requiredParams_1, requiredParams_1_1, param, isCurrencyANative, isCurrencyBNative, liquidityValue, plugin_1, plugin;
            var e_1, _c, e_2, _d;
            return __generator(this, function (_e) {
                _b = params.methodParams, to = _b.to, deadline = _b.deadline, tokenA = _b.tokenA, tokenB = _b.tokenB, liquidity = _b.liquidity;
                requiredParamsExact = [
                    { value: tokenA.value, key: 'tokenA' },
                    { value: tokenB.value, key: 'tokenB' },
                    { value: to.value, key: 'to' },
                ];
                try {
                    for (requiredParamsExact_1 = __values(requiredParamsExact), requiredParamsExact_1_1 = requiredParamsExact_1.next(); !requiredParamsExact_1_1.done; requiredParamsExact_1_1 = requiredParamsExact_1.next()) {
                        param = requiredParamsExact_1_1.value;
                        if (!param.value) {
                            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
                            return [2 /*return*/];
                        }
                        if (typeof param.value !== 'string') {
                            console.error("wrong param ".concat(param.key, ": should be a string"));
                            return [2 /*return*/];
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (requiredParamsExact_1_1 && !requiredParamsExact_1_1.done && (_c = requiredParamsExact_1.return)) _c.call(requiredParamsExact_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                requiredParams = [{ value: to.value, key: 'to' }];
                try {
                    for (requiredParams_1 = __values(requiredParams), requiredParams_1_1 = requiredParams_1.next(); !requiredParams_1_1.done; requiredParams_1_1 = requiredParams_1.next()) {
                        param = requiredParams_1_1.value;
                        if (!param.value) {
                            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
                            return [2 /*return*/];
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (requiredParams_1_1 && !requiredParams_1_1.done && (_d = requiredParams_1.return)) _d.call(requiredParams_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                isCurrencyANative = getIsNative(tokenA.value);
                isCurrencyBNative = getIsNative(tokenB.value);
                if (isCurrencyBNative) {
                    console.error("wrong param currencyB: ".concat(tokenB.value));
                    return [2 /*return*/];
                }
                liquidityValue = isEstimation && isVariable(liquidity.value) ? liquidity.estimatedValue : liquidity.value;
                if (isCurrencyANative) {
                    plugin_1 = new RemoveLiquidityETH({
                        chainId: chainId,
                        initParams: {
                            to: params.to.value,
                            methodParams: {
                                token: tokenB.value,
                                liquidity: liquidityValue,
                                amountTokenMin: '0',
                                amountETHMin: '0',
                                to: to.value,
                                deadline: deadline.value,
                            },
                        },
                    });
                    return [2 /*return*/, { plugin: plugin_1, params: plugin_1.input.params, method: plugin_1.method, gasLimit: plugin_1.gasLimit }];
                }
                plugin = new RemoveLiquidity({
                    chainId: chainId,
                    initParams: {
                        to: params.to.value,
                        methodParams: {
                            tokenA: tokenA.value,
                            tokenB: tokenB.value,
                            liquidity: liquidityValue,
                            amountAMin: '0',
                            amountBMin: '0',
                            to: to.value,
                            deadline: deadline.value,
                        },
                    },
                });
                return [2 /*return*/, { plugin: plugin, params: plugin.input.params, method: plugin.method, gasLimit: plugin.gasLimit }];
            });
        });
    },
    requiredApprovals: function (params, chainId, _walletAddress, _vaultAddress, _provider, _method, isEstimation) {
        var currencyA = params === null || params === void 0 ? void 0 : params.methodParams.tokenA.value;
        var token0 = getIsNative(currencyA) ? ETH({ chainId: Number(chainId) || 1 }).address : currencyA;
        var token1 = params === null || params === void 0 ? void 0 : params.methodParams.tokenB.value;
        var getToken = function () {
            if (token0 && typeof token0 === 'string' && token1 && typeof token1 === 'string') {
                var pairAddress = getCreate2Address(FACTORY_ADDRESS_MAP[Number(chainId)], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH);
                return pairAddress;
            }
            return undefined;
        };
        var amountParam = params === null || params === void 0 ? void 0 : params.methodParams.liquidity;
        var getAmount = function () {
            if (isEstimation) {
                if (isVariable(amountParam.value)) {
                    return amountParam.estimatedValue;
                }
            }
            return amountParam.value;
        };
        return [
            {
                to: getToken(),
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: getAmount() },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
